import * as React from "react";
import * as ReactDOM from "react-dom";
import { Pvjs as PvjsEl } from "./Pvjs";
export class Pvjs {
    constructor(containerEl, data) {
        this._containerEl = containerEl;
        this._renderMethod =
            containerEl.innerHTML.trim() === "" ? "render" : "hydrate";
        this._data = data;
        this.render();
    }
    set data(data) {
        const { _containerEl, _data: prevData } = this;
        const { pathway } = data;
        this._data = data;
        //ReactDOM.unmountComponentAtNode(_containerEl);
        this._renderMethod = "render";
        this.render();
        /*
          const propIds = ["highlighted", "hidden", "pathway", "entitiesById"];
          const stateIds = ["highlighted", "hidden", "pathway", "entitiesById"];
        if (pathway.id !== prevData.pathway.id) {
          ReactDOM.unmountComponentAtNode(_containerEl);
          this._renderMethod = "render";
          this.render();
        } else {
          this._element.setState(data);
        }
          //*/
    }
    render() {
        const { _data, _renderMethod, _containerEl } = this;
        const doRender = ReactDOM[_renderMethod];
        this._element = doRender(React.createElement(PvjsEl, Object.assign({}, _data)), _containerEl);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHZqcy52YW5pbGxhLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3B2anMudmFuaWxsYS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxLQUFLLEtBQUssTUFBTSxPQUFPLENBQUM7QUFDL0IsT0FBTyxLQUFLLFFBQVEsTUFBTSxXQUFXLENBQUM7QUFFdEMsT0FBTyxFQUFFLElBQUksSUFBSSxNQUFNLEVBQUUsTUFBTSxRQUFRLENBQUM7QUFJeEMsTUFBTSxPQUFPLElBQUk7SUFNZixZQUFZLFdBQWdCLEVBQUUsSUFBSTtRQUNoQyxJQUFJLENBQUMsWUFBWSxHQUFHLFdBQVcsQ0FBQztRQUNoQyxJQUFJLENBQUMsYUFBYTtZQUNoQixXQUFXLENBQUMsU0FBUyxDQUFDLElBQUksRUFBRSxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsUUFBUSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQUM7UUFDN0QsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUM7UUFDbEIsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ2hCLENBQUM7SUFFRCxJQUFJLElBQUksQ0FBQyxJQUFTO1FBQ2hCLE1BQU0sRUFBRSxZQUFZLEVBQUUsS0FBSyxFQUFFLFFBQVEsRUFBRSxHQUFHLElBQUksQ0FBQztRQUMvQyxNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsSUFBSSxDQUFDO1FBQ3pCLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDO1FBQ2xCLGdEQUFnRDtRQUNoRCxJQUFJLENBQUMsYUFBYSxHQUFHLFFBQVEsQ0FBQztRQUM5QixJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7UUFDZDs7Ozs7Ozs7OztjQVVHO0lBQ0wsQ0FBQztJQUVELE1BQU07UUFDSixNQUFNLEVBQUUsS0FBSyxFQUFFLGFBQWEsRUFBRSxZQUFZLEVBQUUsR0FBRyxJQUFJLENBQUM7UUFFcEQsTUFBTSxRQUFRLEdBQWEsUUFBUSxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQ25ELElBQUksQ0FBQyxRQUFRLEdBQUcsUUFBUSxDQUFDLG9CQUFDLE1BQU0sb0JBQUssS0FBSyxFQUFJLEVBQUUsWUFBWSxDQUFDLENBQUM7SUFDaEUsQ0FBQztDQUNGIn0=